import { render, staticRenderFns } from "./UIAvatar.vue?vue&type=template&id=aa0aa96e&functional=true&"
import script from "./UIAvatar.vue?vue&type=script&lang=js&"
export * from "./UIAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UIAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports